var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:['pb-0', 'page-header', 'px-3']},[_c('div',{class:['px-2']},[_c('h2',{class:['font-weight-light', 'headline', 'pb-3'],domProps:{"innerHTML":_vm._s(_vm.setHeaderText)}}),_vm._v(" "),_c('v-divider')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-086570ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page-header.vue
// module id = null
// module chunks = 